<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'UserAdminPage',

};
</script>

<style>

</style>
